const main_view = {
    template: require('./view.html'),
};
const state_config = {
    url: '/churn',
    reloadOnSearch: false,
    data: {
        priority: 896,
        title: 'Churn',
    },
    views: {
        '': main_view,
    },
};
export default state_config;
